import {
  isBoe,
  isExternal,
  isKA,
  isVa,
  isJp,
  isSg,
  isVaAt,
  isTemporyMycisBoe,
  isTemporyMycisProd,
  isLarksuiteUnify,
  isMeegleUnify,
} from '../platform/environment';
import configDev from './config.dev';
import configBoe from './config.boe';
import configTemporyMycisBoe from './config.tempory-mycis-boe';
import configBoeExternal from './config.boeExternal';
import configTemporyMycisProd from './config.tempory-mycis';
import configProd from './config.prod';
import configExternal from './config.external';
import configKa from './config.ka';
import configVa from './config.va';
import configJp from './config.jp';
import configVaAt from './config.va-at';
import configLarksuiteUnify from './config.larksuite.unify';
import configMeegleUnify from './config.meegle.unify';

const ENV = /** @__PURE__ */ (() => {
  let config: Record<string, any>;
  if (isKA) {
    config = configKa;
  } else if (window.location.host === 'meego.dev.bytedance.net') {
    config = configDev;
  } else if (isBoe && isExternal) {
    config = configBoeExternal;
  } else if (isBoe && isTemporyMycisBoe) {
    config = configTemporyMycisBoe;
  } else if (isBoe) {
    config = configBoe;
  } else if (isLarksuiteUnify) {
    console.info('[envs/index]: larksuite unify', configLarksuiteUnify);
    config = configLarksuiteUnify;
  } else if (isMeegleUnify) {
    console.info('[envs/index]: meegle unify', configMeegleUnify);
    config = configMeegleUnify;
  } else if (isVa && isJp) {
    config = configJp;
  } else if (isVa && isVaAt) { // 这个判断应该走不到了  isMeegleUnify 拦截了
    config = configVaAt;
  } else if (isVa && isExternal) { // 也走不到
    config = configVa;
  } else if (isExternal) {
    config = configExternal;
  } else if (isTemporyMycisProd) {
    config = configTemporyMycisProd;
  } else {
    config = configProd;
  }

// 多环境使用的资源前缀，一般是使用 meego 上传的附件
  config.generateResouceURL = ({ filename, externalFilename }: {
    filename: string;
    externalFilename: string;
  }) =>
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `${config.host}/goapi/v1/tos/file/${config.tosBucket}/checklist/${
      isExternal ? externalFilename : filename
    }?isConf=1`;
  return config;
})();


export {
  ENV,
  configBoe,
  configDev,
  configBoeExternal,
  configProd,
  configExternal,
  configKa,
  configVa,
};

// 以下只有default导出，default覆盖无意义
// export * from './config.boe';
// export * from './config.boeExternal';
// export * from './config.default';
// export * from './config.dev';
// export * from './config.external';
// export * from './config.ka';
// export * from './config.prod';
// export * from './config.va';
// export * from './config.jp';
